import color from 'atoms/colors/colors';
import shadows from 'atoms/shadows/shadows';
import { padding } from 'atoms/spacing/spacing';
import { fontSize, fontWeight } from 'atoms/typography/typography';

const tooltipRoot = {
  fontSize: fontSize.textXs,
  fontWeight: fontWeight.medium,
  paddingTop: padding[8],
  paddingBottom: padding[8],
  paddingLeft: padding[12],
  paddingRight: padding[12],
  borderRadius: 8,
  boxShadow: shadows.xl,
};

const lightTooltip = {
  MuiTooltip: {
    styleOverrides: {
      tooltip: {
        backgroundColor: color.common.white,
        color: color.gray[700],
        ...tooltipRoot,
      },
      arrow: {
        color: color.common.white,
      },
    },
  },
};

export default lightTooltip;
